// extracted by mini-css-extract-plugin
export default {"scroll-chat-main":"ScrollChat_scroll-chat-main__q+WDb","single-chat":"ScrollChat_single-chat__ZNJh4","user":"ScrollChat_user__mLbl-","gemini":"ScrollChat_gemini__spTlN"};